import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { Link } from '@infl-ts/ui-advocate-components';
import { BlockWidthWrapper } from '@infl-ts/util-block-width-context';
import { resolveNextViteImage } from '@infl-ts/util-resolve-next-vite-image';
import { Box, styled, Typography } from '@mui/material';
import { Translation } from 'react-i18next';
import poweredByInfluitive from './powered_by_@3x.png';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledLogo = styled('img')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 180px;\n  height: auto;\n  object-fit: contain;\n"])));

var InfluitiveLogo = function InfluitiveLogo() {
  return /*#__PURE__*/_jsx(Link, {
    sx: {
      display: 'flex'
    },
    href: "https://influitive.com",
    target: "_blank",
    "aria-label": "Access Influitive.com website",
    "data-element": "Link",
    "data-component": "InfluitiveLogo",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(StyledLogo, {
      src: resolveNextViteImage(poweredByInfluitive),
      alt: "Influitive Logo",
      "data-element": "StyledLogo",
      "data-component": "InfluitiveLogo",
      "data-source-file": "index.tsx"
    })
  });
};

var Separator = function Separator() {
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      mx: 2,
      alignItems: 'center'
    },
    "data-element": "Box",
    "data-component": "Separator",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(Typography, {
      variant: "body2",
      color: "textSecondary",
      "data-element": "Typography",
      "data-component": "Separator",
      "data-source-file": "index.tsx",
      children: "\u2219"
    })
  });
};

var FooterBox = function FooterBox(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(BlockWidthWrapper, {
    "data-element": "BlockWidthWrapper",
    "data-component": "FooterBox",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(Box, {
      sx: {
        display: 'flex',
        width: 1,
        px: 3,
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: {
          xs: 'column',
          md: 'row'
        }
      },
      "data-element": "Box",
      "data-component": "FooterBox",
      "data-source-file": "index.tsx",
      children: children
    })
  });
};

var FooterBlock = function FooterBlock(_ref2) {
  var _ref2$block = _ref2.block,
      influitiveLogo = _ref2$block.influitiveLogo,
      privacyPolicyLink = _ref2$block.privacyPolicyLink,
      termsAndConditionsLink = _ref2$block.termsAndConditionsLink;
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "FooterBlock",
    "data-source-file": "index.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsxs(FooterBox, {
        children: [influitiveLogo ? /*#__PURE__*/_jsx(InfluitiveLogo, {}) : null, /*#__PURE__*/_jsxs(Box, {
          sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: {
              xs: 'column',
              md: 'row'
            },
            mt: {
              xs: 2,
              md: 0
            }
          },
          children: [termsAndConditionsLink ? /*#__PURE__*/_jsx(Link, {
            href: termsAndConditionsLink,
            "aria-label": "View Terms and Conditions",
            color: "textSecondary",
            target: termsAndConditionsLink.startsWith('/') ? undefined : '_blank',
            sx: {
              fontSize: function fontSize(t) {
                return t.typography.body2.fontSize;
              }
            },
            children: t('Terms and Conditions')
          }) : null, termsAndConditionsLink && privacyPolicyLink ? /*#__PURE__*/_jsx(Separator, {}) : null, privacyPolicyLink ? /*#__PURE__*/_jsx(Link, {
            href: privacyPolicyLink,
            "aria-label": "View Privacy Policy",
            color: "textSecondary",
            target: privacyPolicyLink.startsWith('/') ? undefined : '_blank',
            sx: {
              fontSize: function fontSize(t) {
                return t.typography.body2.fontSize;
              }
            },
            children: t('Privacy Policy')
          }) : null]
        })]
      });
    }
  });
};

export default FooterBlock;